import React, { useEffect, useState } from 'react';
import SpotlightCard from '../SpotlightCard/SpotlightCard';
import { BusDataType } from '../types';
import '../../../styles/SpotlightSlider.css';

type SpotlightSliderType = {
  data: BusDataType[];
};

const SpotlightSlider = ({ data }: SpotlightSliderType) => {
  const [deviceWidth, setDeviceWidth] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setLength] = useState(data.length);

  const [touchPosition, setTouchPosition] = useState(null);

  useEffect(() => {
    setDeviceWidth(window.innerWidth);
    setLength(data.length);
  }, [data]);

  const next = () => {
    if (currentIndex < length - 1) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);
  };

  // code for autoscroll commented

  // const timeoutRef = useRef<null | NodeJS.Timeout>(null);

  // function resetTimeout() {
  //   if (timeoutRef.current) {
  //     clearTimeout(timeoutRef.current);
  //   }
  // }

  // useEffect(() => {
  //   resetTimeout();
  //   timeoutRef.current = setTimeout(
  //     () => setCurrentIndex((prevIndex) => (prevIndex === data.length - 1 ? 0 : prevIndex + 1)),
  //     2500
  //   );

  //   return () => {
  //     resetTimeout();
  //   };
  // }, [currentIndex]);

  return (
    <div className="SliderWrapper">
      <div
        className="SliderHolder"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        style={{ transform: `translateX(-${currentIndex * (deviceWidth <= 767 ? 100 : 50)}%)` }}
      >
        {data &&
          data.length > 0 &&
          data.map((item, index) => (
            <div className="SpotlightCardItem" key={'item' + index}>
              <SpotlightCard data={item} />
            </div>
          ))}
      </div>
      <div className="SlideDots slideshowDots">
        {data.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot ${currentIndex === idx ? 'active' : ''}`}
            onClick={() => {
              setCurrentIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default SpotlightSlider;
